






















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class SearchInput extends Vue {
  @Prop()
  private placeholder!: string;

  @Prop({ required: false, default: '' })
  private text!: string;

  private textValue: string = this.text;

  public focus() {
    (this.$refs.textSearchInput as Vue & { focus: () => {} }).focus();
  }

  private search() {
    const word: string = this.textValue.trim();
    if (word.length) {
      this.executeSearch(word);
    } else {
      this.executeEmptySearch();
    }
  }

  @Emit('execute-search')
  private executeSearch(word: string): string {
    return word;
  }

  @Emit('execute-empty-search')
  private executeEmptySearch(): void {}
}
